<template>
    <section>
        <div class="row">
            <div class="col-lg-12">
                <div class="tabs-container">
                    <ul class="nav nav-tabs">
                        <li class="active nav_custom_class"><a data-toggle="tab" href="#subscriptions"> Subscriptions</a></li>
                        <li class="nav_custom_class"><a data-toggle="tab" href="#billings">Billings</a></li>
                    </ul>
                    <div class="tab-content">
                        <div id="subscriptions" class="tab-pane active">
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <SubscriptionHistory ref="SubscriptionHistory"
                                        v-bind:selectedRestaurant="selectedRestaurant"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="billings" class="tab-pane">
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <BillingsHistory ref="BillingsHistory"
                                        v-bind:selectedRestaurant="selectedRestaurant"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </section>
</template>


<script>
    import BillingsHistory from '@/components/billings/BillingsHistory'
    import SubscriptionHistory from '@/components/billings/SubscriptionHistory'
    export default {
        name: "SubscriptionsAndBillings",
        props:["selectedRestaurant"],
        data () {
            return {

            }
        },
        components: {
            BillingsHistory,
            SubscriptionHistory
        },
        mounted: function(){

        },
        computed:{
            refreshDatatable(){
                return this.$store.state.refreshBillingDatatable;
            }
        },

        watch:{
            selectedRestaurant(){
                // this.dtTable.draw();
            },
            refreshDatatable(){
                this.$refs.SubscriptionHistory.dtTable.draw();
                this.$refs.BillingsHistory.dtTable.draw();
                this.$store.dispatch("refreshBillingAndSubscriptionDatatable", false);
            }
        },                 
        methods:{
            endSubscription: async function(subscriptionId){
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                let resp= await this.$http.put(this.$store.state.mainAppURL + "billings/end_subscription/" + subscriptionId)
                Swal.close();
                swal("Ended!" ,"Your Subscription Has Been Ended.", "success");
                this.$parent.getElementByClass= true;
                this.$store.dispatch("refreshBillingAndSubscriptionDatatable", true);
            },
            getClass: function(status){
                switch(status){
                    case 'ongoing':
                        return 'label-primary';
                        break;
                    case 'Ended':
                        return 'label-danger';
                        break;
                    case 'completed':
                        return 'label-success';
                        break;
                }
            }
        }
    }
</script>
<style scoped>
.nav_custom_class{
    width: 50% !important;
}
</style>